// The single demo device this HUD is bound to. Every topic/subscription in
// this app is scoped to weco/<HOSTNAME>/...
export const HOSTNAME = 'denshi';

// The Raspberry Pi alongside the controller in the same unit speaks under two
// further device ids:
//
// - PI_HOSTNAME is the denshi-camera client: its own liveness on
//   weco/denshi-camera/status, and the file announcements the camera panels
//   listen for on weco/denshi-camera/camera.
// - BRIDGE_HOSTNAME is denshi's scripts/denshi_pi_bridge.py, which joins the
//   controller's access point, polls its /api/live and republishes every
//   record as JSON on weco/denshi-pi/<table> with the same table and column
//   names the ingester writes -- so it can stand in, field for field, when
//   the controller's own MQTT link is down.
export const PI_HOSTNAME = 'denshi-camera';
export const BRIDGE_HOSTNAME = 'denshi-pi';

// Wire hostname per source, as useDenshiState and FIELD_MAP name them.
export const SOURCES = { denshi: HOSTNAME, bridge: BRIDGE_HOSTNAME, pi: PI_HOSTNAME };
